import { render } from "./MarginFileImport.vue?vue&type=template&id=03bac1f3"
import script from "./MarginFileImport.vue?vue&type=script&lang=js"
export * from "./MarginFileImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__